module.exports = __webpack_public_path__ + "img/elven_tunic.66f1bc5d.png";